module.exports = __webpack_public_path__ + "images/img-1RhhY6I.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/income.jpg
// module id = 1996
// module chunks = 0